var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNum2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.0161,
    cy: 20.0161,
    r: 19.0161,
    stroke: "#3C8AE8",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9733 25.8722H24.1333V23.3282H20.1333C22.0053 22.0322 24.0213 20.0322 24.0213 17.6002C24.0213 15.6802 22.9173 14.0962 20.1333 14.0962C17.9733 14.0962 16.0373 15.2962 15.9413 18.2722H18.9813C18.9493 17.2322 19.3493 16.7362 19.9413 16.7362C20.5493 16.7362 20.8533 17.1522 20.8533 17.8242C20.8533 19.6482 18.3573 21.6482 15.9733 23.5202V25.8722Z",
    fill: "#FEF9F9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNum2);
export default __webpack_public_path__ + "static/media/num2.b7ff35a66a7451a852a47f7a7d6e8397.svg";
export { ForwardRef as ReactComponent };